import axios from 'axios';
import AppRouter from 'common/AppRouter';
import { API, API_GATEWAY_URI } from 'common/constants/api-urls';
import { getEmailInvitationParams } from 'common/services/invitations.service';
import { postIdentityActions } from 'views/oauth/OAuthHandler.service';

export const requestInvitation = requestInvitationToken => {
  const instance = axios.create({});

  return instance.post(
    `${API.PUBLIC_REQUEST_INVITATION_PATH}`,
    {},
    {
      headers: {
        authorization: `Bearer ${requestInvitationToken}`
      },
      ...getEmailInvitationParams(false)
    }
  );
};

export const createAccountFromJWT = ({
  providerName,
  createAccountToken,
  toggleModal,
  history
}) => {
  const instance = axios.create({});

  const jwtIdentityUrl = `${API_GATEWAY_URI}/api/v1/rest/public/auth/jwt/identity/success/${providerName}`;

  return instance
    .get(jwtIdentityUrl, {
      headers: {
        authorization: `Bearer ${createAccountToken}`
      }
    })
    .then(async ({ data }) => {
      const { token, cookieOptions } = data;
      await postIdentityActions(token, cookieOptions, providerName);
      toggleModal();
      return history.push(AppRouter.ROOT.path);
    });
};
